import React from 'react';
import moment from 'moment';
import { useConfiguration } from '../../context/configurationContext';
import { types as sdkTypes } from '../../util/sdkLoader';
import { FormattedMessage } from '../../util/reactIntl';
import { formatMoney } from '../../util/currency';

import css from './OrderBreakdown.module.css';

const CustomRefundBoxMaybe = props => {
  const { transaction, timeZone, intl, isProvider, marketplaceName } = props;
  const { refundResult = null } = transaction?.attributes?.metadata || {};

  const config = useConfiguration();
  const { currency } = config;
  const { Money } = sdkTypes;

  if (!refundResult) {
    return null;
  }

  const formattedRefundAmount = formatMoney(intl, new Money(refundResult.amount, currency));
  const formattedRefundFee = formatMoney(intl, new Money(refundResult.refundFee, currency));
  const createdInSeconds = refundResult.created / 1000;
  const formattedRefundDate = moment
    .unix(createdInSeconds)
    .tz(timeZone)
    .format('MMM D, YYYY');

  return (
    <div className={css.customRefundBoxWrapper}>
      <p className={css.customRefundBoxTitle}>
        <FormattedMessage id="OrderBreakdown.refundTitle" />
      </p>
      <div className={css.customRefundBoxInfo}>
        <div className={css.customRefundBoxRow}>
          <p className={css.customRefundBoxLabel}>
            <FormattedMessage id="OrderBreakdown.refundAmount" />
          </p>
          <p className={css.customRefundBoxValue}>{formattedRefundAmount}</p>
        </div>
        {isProvider && refundResult.showFeeForProvider ? (
          <div className={css.customRefundBoxRow}>
            <p className={css.customRefundBoxLabel}>
              <FormattedMessage
                id="OrderBreakdown.refundCommission"
                values={{ marketplaceName, role: 'provider' }}
              />
            </p>
            <p className={css.customRefundBoxValue}>{formattedRefundFee}</p>
          </div>
        ) : null}
        <div className={css.customRefundBoxRow}>
          <p className={css.customRefundBoxLabel}>
            <FormattedMessage id="OrderBreakdown.refundDate" />
          </p>
          <p className={css.customRefundBoxValue}>{formattedRefundDate}</p>
        </div>
      </div>
      {refundResult.reason && <p className={css.customRefundBoxReason}>{refundResult.reason}</p>}
    </div>
  );
};

export default CustomRefundBoxMaybe;
